export class LlmClientShort {
  public id: string;
  public llmName: string;
  public clientName: string;
  public isEnabled: boolean;
  public note?: string;

  constructor(data: any) {
    this.id = data.id;
    this.llmName = data.llmName;
    this.clientName = data.clientName;
    this.isEnabled = data.isEnabled;
    this.note = data.note;
  }
}
